export default "/static/ot_2_tiny.png";